import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-grafana-report-orders',
  templateUrl: './grafana-report-orders.component.html',
  styleUrls: ['./grafana-report-orders.component.css']
})
export class GrafanaReportOrdersComponent {
  src: string = '';

  constructor() {
    this.src = `https://main.friggkantine.no/service/grafana/d/47fc49e3-1d3b-4637-952a-b797b3bf7896/overview?orgId=1&from=now-6h&to=now&refresh=30s&timezone=browser&theme=light&kiosk=1`;
  }
}
